const Breakpoints = {
  mobile: 576,
  tablet: 768,
  laptop: 1024,
  desktop: 1440,
};

export default Breakpoints;
